import { render, staticRenderFns } from "./PanelSpinner.vue?vue&type=template&id=47cc825e&scoped=true&"
import script from "./PanelSpinner.vue?vue&type=script&lang=js&"
export * from "./PanelSpinner.vue?vue&type=script&lang=js&"
import style0 from "./PanelSpinner.vue?vue&type=style&index=0&id=47cc825e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc825e",
  null
  
)

export default component.exports